import type { LegalDocId, LegalDocument } from './types';
import { PRIVACY_EN, TERMS_EN, COOKIES_EN, LEGAL_EN } from './content-en';
import { PRIVACY_IT, TERMS_IT, COOKIES_IT, LEGAL_IT } from './content-it';

export type { LegalDocId, LegalDocument, LegalSection } from './types';

export { PRIVACY_EN, TERMS_EN, COOKIES_EN, LEGAL_EN } from './content-en';
export { PRIVACY_IT, TERMS_IT, COOKIES_IT, LEGAL_IT } from './content-it';

import { formatLegalLastUpdated } from './version';

export { LEGAL_VERSION, LEGAL_LAST_UPDATED, formatLegalLastUpdated, formatLegalHeaderLine } from './version';
export { renderLegalParagraph, legalSectionId } from './renderLegalText';

export function getLegalDocument(doc: LegalDocId, lang: 'it' | 'en'): LegalDocument {
  const base = lang === 'it' ? LEGAL_IT[doc] : LEGAL_EN[doc];
  return { ...base, lastUpdated: formatLegalLastUpdated(lang) };
}
